const muiCustomStyles = {
  chipStyles: {
    borderRadius: "6px",
    backgroundColor: "rgba(47, 43, 61, 0.08)",
    color: "rgba(47, 43, 61, 0.9)",
    height: "24px",
    "& .MuiChip-label": {
      px: "8px",
      fontSize: "15px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    "& .MuiChip-deleteIcon": {
      color: "rgba(62, 63, 76, 0.7)",
      fontSize: "16px",
      "&:hover": {
        color: "rgba(62, 63, 76, 0.7)",
      },
    },
  },

  formControl: {
    minWidth: "100%",
  },

  buttonBase: {
    justifyContent: "space-between",
    textTransform: "none",
    borderRadius: "8px",
    borderColor: "rgba(230, 228, 235, 1)",
    color: "rgba(47, 43, 61, 0.9)",
    "&:hover": {
      borderColor: "rgba(36, 139, 112, 1)",
      backgroundColor: "transparent",
    },
    width: "100%",
    "&.Mui-disabled": {
      opacity: 0.5,
    },
  },

  buttonOpen: {
    borderColor: "rgba(36, 139, 112, 1)",
  },

  text: {
    fontSize: "15px",
    fontWeight: 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left",
    flexGrow: 1,
  },

  menuPaper: {
    marginTop: "8px",
    borderRadius: "8px",
    padding: "8px",
    maxHeight: 300,
    overflow: "auto",
  },

  listSubHeader: {
    fontSize: "15px",
    fontWeight: "400",
    p: "6px",
    pt: "18px",
    color: "rgba(72, 72, 72, 1)",
    lineHeight: "20px",
  },

  menuItem: {
    padding: "0px 12px",
    borderRadius: "4px",
    mb: "12px",
    gap: "10px",
    "&.Mui-selected": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
    },
  },

  menuItemText: {
    fontSize: "15px",
    fontWeight: 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  checkbox: {
    padding: 0,
    marginRight: "8px",
    color: "rgba(70, 160, 145, 1)",
    "&.Mui-checked": {
      color: "rgba(70, 160, 145, 1)",
    },
  },

  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px",
    alignItems: "center",
    flex: 1,
  },

  iconLabelWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexWrap: "wrap",
    width: "100%",
    textAlign: "left",
  },
};

export default muiCustomStyles;
